module.exports = __webpack_public_path__ + "img/no-communication.e332e463.svg";